import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import { Tooltip } from '@material-ui/core';
import moment from 'moment';
import React, { Component } from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { withRouter } from "react-router-dom";
import NoData from '../../../assets/images/nodata.png';
import userdefault from '../../../assets/images/userdefault.svg';
import AllCustomerListView from '../CustomersListView/AllCustomerListView/AllCustomerListView';
import handset from '../../../assets/images/handset.svg';
import whitehandset from '../../../assets/images/whitehandset.svg';
import messageblack from '../../../assets/images/messageblack.svg';
import pencilBlack from '../../../assets/images/pencil-gray.svg';
import message from '../../../assets/images/message.svg';
import deletegray from '../../../assets/images/deletegray.svg';
import Bell from '../../../assets/images/bell.svg';
import BellO from '../../../assets/images/bellO.svg';
import MessageForCustomer from '../../modals/MessageForCustomer/MessageForCustomer';
import { ImageBaseUrl } from "../../../Environment";
import { withNamespaces } from 'react-i18next';
import './AllCustomerCardview.scss';
import UpdateCollectionAgent from '../../modals/UpdateCollectionAgent/UpdateCollectionAgent';
import ls from 'local-storage';
import {BaseUrl} from "../../../Environment";
import LoadingPage from '../../modals/LoadingPage/LoadingPage';
import DeleteLoanAlt from '../../modals/DeleteLoanAlt/DeleteLoanAlt';
import { getSecureItem, setSecureItem } from '../../../utilsFunctions';
import axios from 'axios';
import { toast } from "react-toastify";
import { Button, Checkbox } from '@mui/material';
import { Delete, DeleteForever, Undo } from '@mui/icons-material';
import ImageZoomModal from '../../modals/ImageZoomModal';

// const axios = require('axios')


class AllCustomerCardview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      multiDelete: false,
      selectedLoanIds: [],
      whiteimage:"none",
      phoneimage:"",
      messageblack:"",
      message:"none",
      openmodal: false,
      row: "",
      cAgentId:"",
      openModalCA: false,
      caDatas: [],
      // loading: true
    }
  //  this.CardOver =  this.CardOver.bind(this)
  //  this.CardOut = this.CardOut.bind(this)
  }
  detailspage(loanid) {
    this.props.history.push({
      pathname: '/customers/customerinfo',
      state: { loanID: loanid }
    })
    setSecureItem('loanId',loanid)
  }
  CardOver = (index) => {
    const msgBlack = document.getElementById('messageblack'+ index);
    const msg = document.getElementById('message'+ index);
    const handsetEl = document.getElementById('handset'+ index);
    const whiteHandsetEl = document.getElementById('whitehandset'+ index);
    
    if (msgBlack) msgBlack.style.display = "none";
    if (msg) msg.style.display = "";
    if (handsetEl) handsetEl.style.display = "none";
    if (whiteHandsetEl) whiteHandsetEl.style.display = "";
  }
  CardOut = (index) => {
    const msgBlack = document.getElementById('messageblack'+ index);
    const msg = document.getElementById('message'+ index);
    const handsetEl = document.getElementById('handset'+ index);
    const whiteHandsetEl = document.getElementById('whitehandset'+ index);
    
    if (msgBlack) msgBlack.style.display = '';
    if (msg) msg.style.display = 'none';
    if (handsetEl) handsetEl.style.display = "";
    if (whiteHandsetEl) whiteHandsetEl.style.display = "none";
  }

  messagecustomer = (details, value) => {
    this.setState({
      openmodal: true,
      row: details
    })
  }

  allLoansData() {
    let loggedinUser = getSecureItem("loggedinUser")
    console.log("loggedinUser", loggedinUser);
    const headers = {
      'Authorization': 'Bearer ' + getSecureItem('token')
    }
    const allloan = {
      "loanStatus": "Open",
      "loanPaymentStatus": null,
      "companyId":loggedinUser.companyId,
      "branchId": loggedinUser.branchId || null,
    }

    axios.post(BaseUrl + '/loan/getAllLoans', allloan, {
      headers: headers,
    }).then(resp => {
      if(resp.data){
        this.props.AllView({data: resp.data?.data, loading: false});
      }
    })
  }
  closemodal=()=> {
    this.setState({
      openmodal: false
    })
    setTimeout(() => {
      this.allLoansData();
    }, 1000);
  }

  caModal = (details, value) => {
    this.setState({
      openModalCA: true,
      row: details
    })
  }

  closeModalCA=()=> {
    this.setState({
      openModalCA: false
    })
    setTimeout(() => {
      this.allLoansData();
    }, 1000);
  }

  getAllCA = async () => {
    let loggedinUser = getSecureItem("loggedinUser")
    const headers = {
      'Authorization': 'Bearer ' + getSecureItem('token')
    }

    axios.get(`${BaseUrl}/user/getAllUsers?userName=&companyId=${loggedinUser?.companyId}`, {
      headers
    })
    .then((response) => {
      this.setState({ caDatas: response.data?.result})
    })
    .catch((error) => {
      console.log({ error });
      
    });
  }

  updateAutoReminder = async ({loanId, enableAutoRem}) => {
    try {
      const headers = {
        'Authorization': 'Bearer ' + getSecureItem('token')
      }

      const response = await axios.put(`${BaseUrl}/loan/updateAutoReminderSetting`, {
        loanId,
        enableAutoRem,
      }, {
        headers
      });

      if(response.data?.status){
        toast.success('Auto-Reminder updated successfully!', {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
        setTimeout(() => {
          this.allLoansData();
        }, 1000);
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      }
    } catch (error) {
      console.log({ error });
    }
  }

  componentDidMount() {
    this.getAllCA();

    // setTimeout(() => {
    //   this.setState({ loading: false });
    // }, 1000);
  }

  openDelete = () => {
    this.setState({ multiDelete: true });
  }

  undoDelete = () => {
    this.setState({ selectedLoanIds: [], multiDelete: false });
  }

  toggleLoanId = (loanId) => {
    this.setState((prev) => {
      const exists = prev.selectedLoanIds?.includes(loanId);
      return {
        selectedLoanIds: exists
          ? prev.selectedLoanIds.filter(id => id !== loanId)
          : [...prev.selectedLoanIds, loanId]
      };
    });
  };

  deleteLoans = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };
    const payload = {
      id: this.state.selectedLoanIds,
    }

    axios.post(`${BaseUrl}/loan/deleteLoan`, payload , {
      headers
    })
      .then((resp) => {
        // console.log("message", resp);
        if (resp.status == 200) {
          toast.success("Loans deleted successfully", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
          this.setState({ selectedLoanIds: [], multiDelete: false });

          setTimeout(() => {
            this.allLoansData();
          }, 1000);
        }
      })
      .catch((err) => {
        if (err.request.status !== 200) {
          toast.error("Please try again!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      });
  }

  render() {
    toast.configure({});
    const { t, allData, loading } = this.props; 
    // const { loading } = this.state;

    // console.log("=>", this.state.caDatas);

    let newData = allData?.map(data => {
      let amount = 0;
      let totalAmount = 0;
      let percent = 0;
      let penalty = 0;
      if (data.loanCollections.length > 0) {
        data.loanCollections.map((collection, index) => {
          amount = Number(collection.collectionAmount)
          if(collection.paymentType === "FULL")
          {
            totalAmount += amount - penalty
            penalty = 0;
          }
          else {
            totalAmount += amount
            penalty += Number(collection.PenaltyApplied ? collection.PenaltyApplied : 0)
          }

        })
        percent = totalAmount / (data.totalAmountToCollect) * 100
        data.totalAmount = Math.round(percent);
      }
      const today = moment().startOf("day");
      const dueDate = moment(data.nextDueDate || data.startDate).startOf("day");

      let displayStatus = data.loanPaymentStatus || "Due";

      if (displayStatus === "Due" && dueDate.isBefore(today)) {
        displayStatus = "Unmarked Due";
      }

      data.loanPaymentStatus = displayStatus;
      return data;
    }) || [];

    // Loading or No Data conditions
    if (loading) {
      return <LoadingPage isLoading={loading} />;
    }

    if (newData.length === 0) {
      return (
        <div className="absolute-container2">
          <img src={NoData} alt='No Data' className="centered-image2" />
        </div>
      );
    }
  const userPermissions = getSecureItem("UsersAccess");
    return (
        this.props.list !== "list" ?
          <div style={{display: "flex", flexDirection: "column"}}>
          {userPermissions?.editLoan && (
            <div style={{ alignSelf: "flex-end" }}>
              {this.state.selectedLoanIds?.length > 0 && (
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<DeleteForever />}
                  style={{
                    width: "200px",
                    marginBottom: "20px",
                    marginRight: 40,
                  }}
                  onClick={this.deleteLoans}
                >
                  {"Delete Loans"}
                </Button>
              )}
              {this.state.multiDelete ? (
                <Button
                  variant="outlined"
                  startIcon={<Undo />}
                  style={{
                    width: "200px",
                    marginBottom: "20px",
                    marginRight: 40,
                  }}
                  onClick={this.undoDelete}
                >
                  {"Undo Delete"}
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  startIcon={<Delete />}
                  style={{
                    width: "300px",
                    marginBottom: "20px",
                    marginRight: 40,
                  }}
                  onClick={this.openDelete}
                >
                  {"Multi Delete Loans"}
                </Button>
              )}
            </div>
          )}
            <div className="Allcustomercardviewpage">
              <Grid container spacing={1} style={{display: "grid", gridTemplateColumns: "repeat( auto-fill, minmax(300px, 1fr) )"}}>
                {this.props.allData && newData.map((open, index) => {
                  return <Grid item key={open.loanId}>
                    {this.state.multiDelete && (
                      <Checkbox
                        checked={this.state.selectedLoanIds.includes(open.loanId)}  // <-- CONTROLLED
                        onChange={() => this.toggleLoanId(open.loanId)}
                      />
                    )}
                    <div>
                      <Card className="CardDiv" style={{width: "300px", marginInline: 2, marginBlock: 5, padding: "0.5rem"}}  onMouseOver={(event) => this.CardOver(index)} onMouseOut={(event) => this.CardOut(index)}>
                        <CardHeader
                          avatar={
                            <Avatar aria-label="recipe">
                              <ImageZoomModal
                                src={
                                  open.customer?.proofs?.[0]?.proofImagePath
                                    ? ImageBaseUrl + open.customer.proofs[0].proofImagePath
                                    : userdefault
                                }
                                alt={open.customer?.firstName?.charAt(0)?.toUpperCase() || "Profile"}
                                size={open.customer?.proofs?.[0]?.proofImagePath ? 40 : 31}
                                allowDownload={!!open.customer?.proofs?.[0]?.proofImagePath}
                                fileName={`${open.customer?.firstName || "profile"}.jpg`}
                              />
                            </Avatar>
                          }
                          action={
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                            {/* Bell */}
                            {open?.enableAutoRem ? (
                              <Tooltip title="Disable Auto Reminder" placement="top">
                                <img
                                  src={Bell}
                                  alt="bell"
                                  className="message"
                                  onClick={() => this.updateAutoReminder({ loanId: open?.loanId, enableAutoRem: false })}
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Enable Auto Reminder" placement="top">
                                <img
                                  src={BellO}
                                  alt="bellO"
                                  className="message"
                                  onClick={() => this.updateAutoReminder({ loanId: open?.loanId, enableAutoRem: true })}
                                />
                              </Tooltip>
                            )}

                            {/* Edit — single icon, no duplicate display:none hack */}
                            {userPermissions?.editLoan && (
                              <Tooltip title="Edit" placement="top">
                                <img
                                  src={pencilBlack}
                                  alt="edit"
                                  className="message"
                                  style={{ marginTop: '10px', cursor: 'pointer' }}
                                  onClick={this.caModal.bind(this, open)}
                                />
                              </Tooltip>
                            )}

                            {/* Delete */}
                            {userPermissions?.editLoan && (
                              <Tooltip title="Delete" placement="top">
                                <img
                                  src={deletegray}
                                  alt="delete"
                                  className="message"
                                  style={{ marginTop: '10px', cursor: 'pointer' }}
                                  id={"deletegray" + index}
                                  onClick={this.messagecustomer.bind(this, open)}
                                />
                              </Tooltip>
                            )}
                          </div>
                        }
                          title={
                            <div className="NameDiv Fonts">{(open.customer.firstName+" "+open.customer.lastName)?.length > 15 ? (open.customer.firstName+" "+open.customer.lastName)?.slice(0, 15) + "..." : (open.customer.firstName+" "+open.customer.lastName)}</div>
                          }
                          
                          subheader={
                            <div style={{marginTop: -15}}>
                            {open.customer.cust_id ? <p style={{marginBottom: -15, padding: 0, fontWeight: "bold"}} className='subheadingnameDiv Fonts'>({open.customer.cust_id})</p> : null}
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                              <p className="subheadingnameDiv Fonts">{open.loanId}</p>
                              <div style={{display: "flex", flexDirection: "row"}}>
                                <img src={handset} alt="handset" id={"handset"+index} className="handset" style={{ width: "8px", marginRight: "5px", marginLeft: "5px", display:'' }} />
                                <img src={whitehandset} alt="whitehandset" id={"whitehandset" +index} className="whitehandset" style={{ width: "8px", marginRight: "5px", marginLeft: "5px", display:'none' }} />
                                <p className="subheadingnameDiv Fonts">{open.customer.phone}</p>
                              </div>
                            </div>
                            </div>
                          }
                        />
                        <CardContent onClick={this.detailspage.bind(this, open.loanId)}>
                          <CardHeader
                            avatar={
                              <div style={{ borderRadius: '50%', backgroundColor: 'transparent', width: '53px' }}>
                                <CircularProgressbar value={open.totalAmount ? open.totalAmount : 0} text={`${open.totalAmount ? open.totalAmount : 0}%`} styles={buildStyles({ textColor: '#3E4664', pathColor: '#00D95E', trailColor: '#D2D2DC', textSize: '30px' })} />
                              </div>
                            }

                            title={
                              <div style={{display:"flex"}}>
                              <div className="MoneydetailsDiv Fonts">{open.totalAmountToCollect}</div>
                             {open.method ==="EMI Method" && open.rateOfInterest? <div className="MoneydetailsDiv Fonts">&nbsp; at &nbsp;{open.rateOfInterest || ""} %</div>:" "}
                              </div>
                            }
                            subheader={
                              <div>
                                <div className="subheaderDiv">
                                  <div
                                      className="subheaderStatus Fonts"
                                      style={
                                        open.loanPaymentStatus === "OverDue"
                                          ? {
                                              backgroundColor: "#FFE5E5",
                                              color: "#FF0000",
                                            }
                                          : open.loanPaymentStatus === "Unmarked Due"
                                            ? {
                                                backgroundColor: "#FFF9E5",
                                                color: "#FFA500",
                                              }
                                            : {
                                                backgroundColor: "#EDEFFE",
                                                color: "#4D66F0",
                                              }
                                      }
                                    >
                                      {open.loanPaymentStatus
                                        ? open.loanPaymentStatus
                                        : "Due"}
                                    </div>
                                  <div className="subheaderDays Fonts">{open.method ==="EMI Method" ? "EMI" : open.method ==="Collection method" ? "CMI" : open.method ==="Flexi EMI" ? "F-EMI" : "BMI"}</div>
                                </div>
                                <div style={{ textTransform: "capitalize" }} className="loantypename Fonts">{open.loanType.loanType} | {open.user.firstName}</div>
                              </div>
                            }
                          />
                        </CardContent>
                        <CardActions disableSpacing>
                          <div style={{ display: 'flex', width: '100%', marginTop: '5px' }}>
                            <div className="footerDiv1">
                              <div className="footerDivdate Fonts">{moment(open.nextDueDate ? open.nextDueDate : open.startDate).format("DD MMM YYYY")}</div>
                              <div className="footerDivdatedetails Fonts">{t('Loans.Date')}</div>
                            </div>
                            <div className="footerDiv2" style={{flexDirection: "column"}}>
                              <div className="footerDivmonth Fonts">{open.loanTenureType}</div>
                              <div className="footerDivmonthdetails Fonts">{t('Loans.Collseq')}</div>
                            </div>
                          </div>
                        </CardActions>
                      </Card>
                    </div>

                  </Grid>
                })}
              </Grid>
              {/* <MessageForCustomer open={this.state.openmodal} close={this.closemodal} rowData={this.state.row} /> */}
              <DeleteLoanAlt open={this.state.openmodal} close={this.closemodal} rowData={this.state.row}/>
              <UpdateCollectionAgent open={this.state.openModalCA} close={this.closeModalCA} rowData={this.state.row} caData={this.state.caDatas} />
            </div>
          </div>
          :
          <AllCustomerListView />
    )
  }
}
export default withNamespaces()(withRouter(AllCustomerCardview));